import api, { isMockEnabled } from './axiosConfig';
import { FAMILY_ENDPOINT } from './apiEndpoints';
import { logError } from './errorLogService';

// const mockFamilyData =
//     [
//         {
//             id: 2001,
//             image_src: "/assets/images/portfolio/family-2001.jpg",
//             image_alt: "Reinbow herbicides",
//             description: "Herbicides",
//             order: 1
//         },
//         {
//             id: 2002,
//             image_src: "/assets/images/portfolio/family-2002.jpg",
//             image_alt: "Reinbow Fungicides",
//             description: "Fungicides",
//             order: 2
//         },
//         {
//             id: 2003,
//             image_src: "/assets/images/portfolio/family-2003.jpg",
//             image_alt: "Reinbow Insecticides",
//             description: "Insecticides",
//             order: 3
//         },
//         {
//             id: 2005,
//             image_src: "/assets/images/portfolio/family-2005.jpg",
//             image_alt: "Reinbow Treatment",
//             description: "Seeds Treatment",
//             order: 4
//         },
//         {
//             id: 2004,
//             image_src: "/assets/images/portfolio/family-2004.jpg",
//             image_alt: "Reinbow Plant Growth Regulators",
//             description: "Plant Growth Regulators",
//             order: 5
//         },
//         {
//             id: 2008,
//             image_src: "/assets/images/portfolio/family-2008.jpg",
//             image_alt: "Reinbow Bio-Fertilizers",
//             description: "Bio-Fertilizers",
//             order: 6
//         },
//         {
//             id: 2007,
//             image_src: "/assets/images/portfolio/family-2007.jpg",
//             image_alt: "Reinbow Bio-Pesticides",
//             description: "Bio-Pesticides",
//             order: 7
//         },
//         {
//             id: 2006,
//             image_src: "/assets/images/portfolio/family-2006.jpg",
//             image_alt: "Reinbow Biostimulants",
//             description: "Biostimulants",
//             order: 8
//         },
//     ];

export const fetchFamily = async () => {
    // if (isMockEnabled) {
    //     return mockFamilyData; // Usa datos mock si está activado
    // }

    try {
        const response = await api.get(FAMILY_ENDPOINT());

        const data = response.data.map((item) => ({
            id: item.id,
            description: item.description.trim(),
            image_src: `/assets/images/portfolio/family-${item.id}.jpg`,
            image_alt: `Rainbow ${item.description}`,
            icon_src: item.icon_src || `/assets/images/product-page/Icono-${item.id}.svg`,
        }));
        return data;
    } catch (error) {
        console.error("Error fetching hero data", error);

        await logError('family_data_fetch', error, {
            endpoint: FAMILY_ENDPOINT(),
            response_status: error.response?.status,
            response_data: error.response?.data,
        });

        throw error;
    }
};
